// 判断是否为开发环境
export const isDevelopment = () => import.meta.env.MODE === 'development';

// 判断是否为生产环境
export const isProduction = () => import.meta.env.MODE === 'production';

// 判断是否为测试环境
export const isTest = () => import.meta.env.MODE === 'test';

// 判断是否为本地开发环境（根据 hostname 判断）
export const isLocalDevelopment = () => {
  const hostname = window.location.hostname;
  // 检查 hostname 是否包含 localhost 或 192.168
  return hostname.includes('localhost') || hostname.includes('192.168') || hostname === '127.0.0.1';
};
